// index.js
import React from "react";
import ReactDOM from "react-dom"; // Correct import
import "./index.scss";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/store";
import Modal from "react-modal";

Modal.setAppElement("#root");

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
